import { useMutation } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import { queryClient } from "@/ajax/queryClient";

export function useRevealProvider({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}) {
  const trpc = useTRPC();

  return useMutation(
    trpc.organization.revealProvider.mutationOptions({
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: trpc.profile.list.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.profile.getSharedUser.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.jobPost.getInterestedCandidates.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.providerPool.get.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.credentialFiles.getCredentialsFields.queryKey(),
          }),
        ]);
        onSuccess?.();
      },
      onError,
    }),
  );
}
